import React from 'react'
import Typewriter from 'typewriter-effect';

const TypewriterDev = () => {

  return (
    <Typewriter
        onInit={(typewriter) => {
            typewriter.pauseFor(3000)
            .typeString('Web Developer')
            .pauseFor(2000)
            .deleteAll()
            .typeString('Industrial Engineer')
            .pauseFor(2000)
            .deleteAll()
            .typeString('FullStack Developer')
            .pauseFor(2000)
            .deleteAll()
            .typeString('Backend Developer')
            .pauseFor(2000)
            .start()
        }}
        options= {{
            loop:true,
            cursor: '_'
        }}
    />
  )
}

export default TypewriterDev
